export * from './lib/new-core.module';
export * from './lib/config/mobile-paths.config';
export * from './lib/config/web-paths.config';
export * from './lib/redux/router/router.selectors';
export * from './lib/services/url-data.service';
